(ns common.widgets.tag-input
  (:require ["@mui/material/Autocomplete$default" :as Autocomplete]
            ["@mui/material/TextField$default" :as TextField]
            [clojure.string :as str]
            [common.util :refer [spread-props]]
            [uix.core :as uix :refer [$ defui]]))

(defui tag-input
  [{:keys [options on-change value size error placeholder class text-field-props
           auto-focus? clearable? disabled? multi? open-on-focus?] :as props
    :or {multi? true
         clearable? false
         auto-focus? false
         open-on-focus? false
         size "small"}}]
  (let [[options* set-options*] (uix/use-state (fn []
                                                 (->> (set options)
                                                      (sort-by str/lower-case)
                                                      vec)))]
    ($ Autocomplete
       (-> props
           (dissoc :options :on-change :value :size :error :placeholder :class :text-field-props
                   :auto-focus? :clearable? :disabled? :multi? :open-on-focus?)
           (assoc :free-solo true
                  :options (clj->js options*)
                  :value (clj->js (or value (if multi? [] "")))
                  :class (cond-> []
                           class (conj class)
                           multi? (conj "MuiAutocomplete-multi")
                           true flatten)
                  :multiple multi?
                  :disabled disabled?
                  :disable-clearable (not clearable?)
                  :open-on-focus open-on-focus?
                  :size size
                  :renderInput (fn [^js props]
                                 ($ TextField
                                    (spread-props
                                     props
                                     {:error error
                                      :placeholder placeholder
                                      :autoFocus auto-focus?}
                                     text-field-props)))
                  :on-change (fn [^js _event ^js value]
                               (let [value* (js->clj value)]
                                 (set-options* (fn [options*]
                                                 (into options* (remove (set options*)) value*)))
                                 (when (some? on-change)
                                   (on-change value*))))
                  :filter-options (fn [_ ^js params]
                                    (let [input (.-inputValue params)]
                                      (-> options*
                                          (->> (filterv (fn [option] (str/includes? (str/lower-case option) input))))
                                          (as-> filtered-options
                                            (cond-> filtered-options
                                              (and (empty? filtered-options)
                                                   (not (str/blank? input)))
                                              (conj input)))
                                          clj->js)))
                  :sx #js {".MuiAutocomplete-inputRoot" #js {:row-gap 0.5}
                           ".MuiAutocomplete-tag" #js {:margin "0 2px"}})))))
